class PotsContainer extends PIXI.Container {
  constructor() {
    super();

    gameController.reelData = [];

    messageBus.subscribe(
      "spinner:GameConfigEvent",
      this.onGameConfigEvent.bind(this)
    );
    Reflex.registerEventHandler(
      "layoutChange",
      this.onOrientationChange.bind(this)
    );
    this.megapotGlobalValue = 0;
  }

  onGameConfigEvent() {}

  updatePots(stake) {
    // in golden bet the pot values are based on the base stake
    let goldenBetButton = resourceManager.get("goldenBetToggleButton");
    if (
      goldenBetButton !== undefined &&
      goldenBetButton._flags.showGoldenBetActive
    ) {
      stake = stake / gameData.luckyBetUplift;
    }

    this.miniPotValue.setText(
      gdk.formatCurrency(gameData.potData.mini * (stake / 10))
    );
    this.minorPotValue.setText(
      gdk.formatCurrency(gameData.potData.minor * (stake / 10))
    );
    this.majorPotValue.setText(
      gdk.formatCurrency(gameData.potData.major * (stake / 10))
    );
    this.megaPotValueTop.setText(
      gdk.formatCurrency(gameData.potData.mega * (stake / 10))
    );
    this.megapotGlobalValue = gameData.potData.mega * (stake / 10);
    this.megaPotValue.setText(
      gdk.formatCurrency(gameData.potData.mega * (stake / 10))
    );
  }

  initialise() {
    this.miniPotValue = resourceManager.get(
      "potsContainer:miniPotContainer:miniBox:value"
    );
    this.minorPotValue = resourceManager.get(
      "potsContainer:minorPotContainer:minorBox:value"
    );
    this.majorPotValue = resourceManager.get(
      "potsContainer:majorPotContainer:majorBox:value"
    );
    this.megaPotValue = resourceManager.get(
      "potsContainer:megaPotContainer:megaBox:value"
    );
    this.megaPotValueTop = resourceManager.get("potsContainer:valueTop");
    this.megaPotValueTop.visible = false;

    this.miniParticle = resourceManager.get(
      "potsContainer:miniPotContainer:particleContainer"
    );
    this.minorParticle = resourceManager.get(
      "potsContainer:minorPotContainer:particleContainer"
    );
    this.majorParticle = resourceManager.get(
      "potsContainer:majorPotContainer:particleContainer"
    );
    this.megaParticle = resourceManager.get(
      "potsContainer:megaPotContainer:particleContainer"
    );
    this.centreParticle = resourceManager.get(
      "potsContainer:centreParticleContainer"
    );

    this._particleEmitter = particleManager.createEmitter(
      "coin_emitter",
      "slotContainer:reelEffects:particleContainer",
      0,
      0,
      false
    );
    this._particleEmitter.particleEmitter.emit = false;

    this._centreParticles = undefined;
    this.maxCentralDest = undefined;

    this.megaOrginalPos = undefined;
    this.winPanelPos = undefined;
    this.offsetX = 0;
  }

  onOrientationChange() {
    switch (layoutController.getCurrentLayout()) {
      case "landscape_default":
      case "landscape_mobile": {
        this.maxCentralDest = { x: 687, y: 360 };
        resourceManager.get("potsContainer:valueTop").scale.set(1);
        this.winPanelPos = { x: 685, y: 640 };
        this.megaOrginalPos = { x: 90, y: 94 };

        break;
      }

      case "portrait_default":
      case "portrait_mobile":
      default: {
        this.maxCentralDest = { x: 365, y: 640 };
        resourceManager.get("potsContainer:valueTop").scale.set(1.2);
        this.winPanelPos = { x: 365, y: 780 };
        this.megaOrginalPos = { x: 358, y: 340 };
        break;
      }
    }
    if (this.moveMegaTween) {
      this.moveMegaTween.progress(1);
    }
  }

  moveMegaValue(cb) {
    this.onOrientationChange();

    this.offsetX = 0;

    this.megaOrginalScale = {
      x: this.megaPotValueTop.scale.x,
      y: this.megaPotValueTop.scale.y,
    };

    this.moveMegaTween = gsap
      .timeline()
      .fromTo(
        this.megaPotValueTop,
        {
          x: this.megaOrginalPos.x,
          y: this.megaOrginalPos.y,
          pixi: {
            scaleX: this.megaOrginalScale.x,
            scaleY: this.megaOrginalScale.y,
          },
        },
        {
          duration: 0.5,
          onStart: () => {
            this.megaPotValueTop.visible = true;
          },
          x: this.maxCentralDest.x,
          y: this.maxCentralDest.y,
          pixi: { scaleX: 3, scaleY: 3 },
          ease: "power4.in",
        }
      )
      .to(this.megaPotValueTop, {
        pixi: {
          scaleX: 3.5,
          scaleY: 3.5,
        },
        duration: 0.4,
        ease: "Bounce.easeOut",
      })
      .to(this.megaPotValueTop, {
        delay: 0.5,
        x: this.winPanelPos.x,
        y: this.winPanelPos.y,
        pixi: { scaleX: 0.2, scaleY: 0.2 },
        duration: 0.5,
        ease: "power4.out",
        onComplete: () => {
          this.megaPotValueTop.visible = false;
          this.megaPotValueTop.scale.x = this.megaOrginalScale.x;
          this.megaPotValueTop.scale.y = this.megaOrginalScale.y;
          this.megaPotValueTop.x = this.megaOrginalPos.x;
          this.megaPotValueTop.y = this.megaOrginalPos.y;
          this.animateCentreParticleOut();
          cb();
          this.moveMegaTween = undefined;
        },
      });
  }

  animatePot(type) {
    let potToAnimate = this[`${type.toLowerCase()}PotValue`];
    let potScale = potToAnimate.scale.x;

    gsap.fromTo(
      potToAnimate,
      { pixi: { scaleX: potScale, scaleY: potScale } },
      {
        pixi: { scaleX: potScale + 0.2, scaleY: potScale + 0.2 },
        duration: 0.8,
        ease: "Bounce.easeOut",
        onStart: () => {
          this.animateParticle(type);
        },
        onComplete: () => {
          potToAnimate.scale.set(potScale);
          this[`${type.toLowerCase()}Particle`].removeChild(
            this[`${type.toLowerCase()}Particle`].children[0]
          );
        },
      }
    );
  }

  animateParticle(type) {
    this[`${type.toLowerCase()}Particle`].addChild(this._particleEmitter);
    this._particleEmitter.particleEmitter.cleanup();
    this._particleEmitter.particleEmitter.emit = true;
  }

  animateCentreParticleIn() {
    this._centreParticles = particleManager.createEmitter(
      "bigwin_emitter",
      "bigWinParticlesContainer",
      0,
      0,
      true
    );

    this._centreParticles.particleEmitter.emit = true;

    resourceManager
      .get("potsContainer:centreParticleContainer")
      .addChild(this._centreParticles);

    gsap.fromTo(
      this._centreParticles,
      { alpha: 0 },
      {
        alpha: 1,
        delay: 0.25,
        duration: 0.5,
        onStart: () => {
          this._centreParticles.visible = true;
        },
      }
    );
  }

  animateCentreParticleOut() {
    gsap.fromTo(
      this._centreParticles.visible,
      { alpha: 1 },
      {
        alpha: 0,
        duration: 0.25,
        onComplete: () => {
          this._centreParticles.visible = false;
          this._centreParticles = undefined;
        },
      }
    );
  }

  onGameConfigEvent() {
    this.initialise();
  }
}

var potsContainerCreator = function (json) {
  return new PotsContainer();
};

var potsContainerInitialiser = function (json, buggy) {};

var potsContainerFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "PotsContainer",
  potsContainerCreator,
  potsContainerInitialiser,
  potsContainerFilesRequired
);
